/**
 * Dashboard commission tile wording (queue #410, phase 1).
 *
 * The figure is Sum(total_commission) over every CURRENT calculation in the
 * selected policy-date window (GET /commissions/calculations/summary/), whatever
 * its status: calculated, paid, disputed and cancelled rows are all included,
 * so it is neither "paid" nor "payable". Agents (posp / super_posp) see their
 * own share; broker roles see the broker commission pool.
 */
export const COMMISSION_CARD_LABEL = 'Commission (accrued)';

export const COMMISSION_CARD_TOOLTIP =
  'Total commission calculated on policies issued in the selected period, whether or not it has been paid. ' +
  'It includes paid, unpaid, disputed and cancelled calculations, and excludes superseded (recalculated) versions. ' +
  'Agents see their own share; brokers see the broker commission.';
